import { render, staticRenderFns } from "./ResetPasswordComplete.vue?vue&type=template&id=29f43cf2&scoped=true&"
import script from "./ResetPasswordComplete.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f43cf2",
  null
  
)

export default component.exports